function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "5CA65C57-6268-4491-9BFB-AB42F21FFB71");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Story-editor-NEW",
  transform: "translate(-77.000000, -54.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-9",
  transform: "translate(55.000000, 40.000000)"
}, React.createElement("g", {
  id: "Group-8"
}, React.createElement("g", {
  id: "opened-door-aperture",
  transform: "translate(22.000000, 14.000000)"
}, React.createElement("path", {
  d: "M6.83959712,0 L6.83959712,1.7464203 L0,1.7464203 L0,36.5910432 L2.52859443,36.5910432 L2.52859443,4.27141279 L6.83959712,4.27141279 L6.83959712,39.6 L23.6,36.5910432 L23.6,31.6673762 L23.6,3.01522843 L6.83959712,0 Z M9.92289929,21.1571744 C9.35949531,21.1571744 8.90270086,20.5636971 8.90270086,19.8315996 C8.90270086,19.0995825 9.35949531,18.5061052 9.92289929,18.5061052 C10.4863033,18.5061052 10.9430977,19.0995825 10.9430977,19.8315996 C10.9430977,20.5636971 10.4863033,21.1571744 9.92289929,21.1571744 Z",
  id: "Shape"
}))))));

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "40px",
    viewBox: "0 0 24 40",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.703d8cb2.svg";
export { ForwardRef as ReactComponent };